// stores/videoModulesStore.ts
import { defineStore } from 'pinia'

export type VideoModule = {
    id: number
    slug: string
    title: string
    description: string | null
    sortOrder: number
    imagePath?: string | null
    imageUpdatedAt?: string | null
    imageSrc?: string | null
}



export const useVideoModulesStore = defineStore('videoModules', () => {
    const modules = ref<VideoModule[]>([])
    const loading = ref(false)
    const loaded = ref(false)

    // NEW: remember we fetched at least once
    const fetchedAt = ref<number>(0)

    async function fetchModules(opts?: { force?: boolean }) {
        const force = !!opts?.force

        const { authToken } = useACookie()
        const t = authToken.value?.trim()
        if (!t) return

        // ✅ If already loaded (or fetched recently), don't refetch
        if (!force && (loaded.value || fetchedAt.value > 0)) return

        loading.value = true
        try {
            const r: any = await $fetch('/api/v1/videos/modules/list', {
                method: 'POST',
                headers: { Authorization: `Bearer ${t}` },
            })

            if (r?.statusCode === 200 && Array.isArray(r?.modules)) {
                modules.value = r.modules
                loaded.value = true
                fetchedAt.value = Date.now()
            } else {
                modules.value = []
                loaded.value = false
                fetchedAt.value = 0
            }
        } finally {
            loading.value = false
        }
    }

    return { modules, loading, loaded, fetchedAt, fetchModules }
})